import './DesignThird.css'; 
let DesignThird =(props)=> {

    let Checkemptyentry = {
        AcademicStream : props.AcademicData,
        TechnicalTrade : props.TechDataexp,
        ComputerCourse : props.ComputerData,
        ExperienceYears : props.ExperienceData,
        PassPortNumber : props.sendpassportdata, 
        HeIght : props.sendphysicaldata,
    };
    



    let Checkemptyvaluesatdesthird = ()=> {
        let AcademicParent = document.querySelector(".Academic_table_main");
        let TechnicalParent = document.querySelector(".Technical_table_main");
        let ComputerParent = document.querySelector(".Computer_table_main");
        let ExperienceParent = document.querySelector(".working_exp_cont");  
        let passportdatacont = document.querySelector('.DesThirdpassportdet');
        let physicaldatacont = document.querySelector('.DesThirdphysicaldet');


        if(Checkemptyentry.AcademicStream == ""){ 
            AcademicParent.style.display = "none";
        }
        if(Checkemptyentry.TechnicalTrade == ""){
            TechnicalParent.style.display = "none";
        } 
        if(Checkemptyentry.ComputerCourse == ""){
            ComputerParent.style.display = "none";
        }
        if(Checkemptyentry.ExperienceYears == ""){
            ExperienceParent.style.display = "none"
        }
        if(Checkemptyentry.PassPortNumber == ""){
            passportdatacont.style.display = "none"
        }
        if(Checkemptyentry.HeIght == ""){
            physicaldatacont.style.display = "none"
        }

    }

    setTimeout(() => {
        Checkemptyvaluesatdesthird();
    }, 100);
    

    let printfunction=()=>{
        window.print();
       
    }


    return(
        <div className='desthird_main_cont'>
            <div className='descont'>

                <h2 className='res_heading'>Resume</h2>  
                <div className='address_date_cont'>
                    <div className='address_contt'>
                        <h3 className='name_heading add_name_heading'>{props.Userdata.applicantname}{props.UsersPersonlD.Name}</h3>
                        <h3 className='address_heading add_name_heading'>Full Address</h3>
                        <div className='same_style_address'>
                            <span>House No:-</span><span>{props.UsersPersonlD.hnum}{props.Userdata.Hnum},</span>
                        </div>
                        <div className='same_style_address'>
                            <span>Vill-</span><span>{props.UsersPersonlD.Village}{props.Userdata.Vill},</span>
                        </div>
                        <div className='same_style_address'>
                            <span>Post-</span><span>{props.UsersPersonlD.Post_Office}{props.Userdata.post},</span>
                        </div>
                        <div className='same_style_address'>
                            <span>Thana-</span><span>{props.UsersPersonlD.Thana}{props.Userdata.police},</span> 
                        </div>
                        <div className='same_style_address'>
                            <span>District-</span><span>{props.UsersPersonlD.District}{props.Userdata.city},</span>
                        </div>
                        <div className='same_style_address'>
                            <span>State-</span><span>{props.UsersPersonlD.State}{props.Userdata.state},</span>
                        </div>
                        <div className='same_style_address'>
                            <span>Pin Code-</span><span>{props.UsersPersonlD.Pin_Code}{props.Userdata.pincode},</span>
                        </div>
                        <div className='same_style_address'>
                            <span>Mobile NO:-</span><span>{props.UsersPersonlD.mobnum}{props.Userdata.MobileNum}</span>
                        </div>
                        <div className='same_style_address'> 
                            <span>Email Id:-</span><span>{props.UsersPersonlD.Email_ID}{props.Userdata.Email}</span>
                        </div>
                    </div>
                    <div className='date_cont'>
                        <div className='image_cont'>
                                {
                                    props.imagedataexp === "" ?  <img alt='photo' className='desthird_img' src={props.UsersPersonlD.Imagge}/> : <img alt='photo' className='desthird_img' src={props.imagedataexp}/>
                                }
                            <span className='date_h2'>Dob-{props.UsersPersonlD.dob}{props.Userdata.date}</span>
                        </div>
                    </div>
                </div>
                <p style={{margin: "0", padding: "0", color:"green", fontWeight: "bold"}}>Carrier Objective:-<span style={{fontWeight: 'normal', color:"black"}}>{props.UsersPersonlD.cardata}{props.carrierdataf}</span></p>
                <div className='body_part_resume'> 
                    <h3 className='personal_det_heading'>Personal Details</h3>
                    <table className='personal_det_table'>
                        <tbody>
                            <tr>
                                <td>NAME</td>
                                <td>{props.UsersPersonlD.Name}{props.Userdata.applicantname}</td>
                            </tr>
                            <tr>
                                <td>Father's Name</td>
                                <td>{props.UsersPersonlD.fname}{props.Userdata.fathername} </td>
                            </tr>
                            <tr>
                                <td>Mother's Name</td>
                                <td>{props.UsersPersonlD.Mname}{props.Userdata.mothername}</td>
                            </tr>
                            <tr>
                                <td>Date Of Birth</td>
                                <td>{props.UsersPersonlD.dob}{props.Userdata.date}</td>
                            </tr>
                            <tr>
                                <td>Nationality</td>
                                <td>{props.UsersPersonlD.Nationality}{props.Userdata.nationality}</td>
                            </tr>
                            <tr> 
                                <td>Religion</td>
                                <td>{props.UsersPersonlD.Religion}{props.Userdata.religion}</td>
                            </tr>
                            <tr>
                                <td>Marrital Status</td>
                                <td>{props.UsersPersonlD.Marital_Status}{props.Userdata.maritalstatus}</td>
                            </tr>
                            <tr>
                                <td>Languages</td>
                                <td>{props.UsersPersonlD.Languages}{props.Userdata.language}</td> 
                            </tr>
                            <tr>
                                <td>Hobbies</td>
                                <td>{props.UsersPersonlD.Hobbies}{props.Userdata.hobbies}</td>
                            </tr>
                        </tbody>
                    </table> 
                    <table className='Academic_table_main samestylingallcomponent'>
                        <caption>Academinc Qualification</caption>
                            <thead>
                                <tr>
                                    <td className='desthird_acadm_td samestyling_td'>Stream</td>
                                    <td className='desthird_acadm_td samestyling_td'>Board/Univercity</td>
                                    <td className='desthird_acadm_td samestyling_td'>Passing Year</td>
                                    <td className='desthird_acadm_td samestyling_td'>%AGE</td>
                                </tr>  
                            </thead>
                            <tbody className='tbody_cont'>
                                {  
                                    props.AcademicData.map(
                                        AcAData =>(
                                            <tr>
                                            <td className='acad_td_loop'>{AcAData.ExamName}</td>
                                            <td className='acad_td_loop'>{AcAData.BoardName}</td>
                                            <td className='acad_td_loop'>{AcAData.PassingYear}</td>
                                            <td className='acad_td_loop'>{AcAData.PercentAge}</td>
                                            
                                        </tr>
                                        )
                                    )
                                }
                            </tbody>
                        </table>
                        <table className='Computer_table_main samestylingallcomponent'>
                            <caption>Computer Qualification</caption>
                            <thead>
                                <tr>
                                    <td className='desthird_comp_td samestyling_td'>Exam Name</td>
                                    <td className='desthird_comp_td samestyling_td'>From</td>
                                    <td className='desthird_comp_td samestyling_td'>Passing Year</td>
                                    <td className='desthird_comp_td samestyling_td'>%Age</td>
                                </tr>
                            </thead>
                            <tbody className='tbody_cont'>
                                    { 
                                        props.ComputerData.map(
                                            CompData => (
                                                <tr>
                                                    <td className='acad_td_loop'>{CompData.CourseName}</td>
                                                    <td className='acad_td_loop'>{CompData.Frompass}</td>
                                                    <td className='acad_td_loop'>{CompData.Compassingy}</td>
                                                    <td className='acad_td_loop'>{CompData.compercent}</td>
                                                    
                                                </tr>
                                    
                                            )
                                        )
                                    }
                                </tbody>
                        </table>
                        <table className='Technical_table_main samestylingallcomponent'>
                            <caption>Techincal Qualification</caption>
                            <thead>
                                <tr>
                                    <td className='desthird_tech_td samestyling_td'>Exam Name</td>
                                    <td className='desthird_tech_td samestyling_td'>From</td>
                                    <td className='desthird_tech_td samestyling_td'>Passing Year</td>
                                    <td className='desthird_tech_td samestyling_td'>%Age</td>
                                </tr>
                            </thead>
                                {
                                    props.TechDataexp.map(
                                        techdataaa =>(
                                            <tbody>
                                                    <tr>
                                                    <td className='tech_loop_td'>{techdataaa.TechCourseName}</td>
                                                    <td className='tech_loop_td'>{techdataaa.TechTradeName}</td>
                                                    <td className='tech_loop_td'>{techdataaa.TechPassingYear}</td>
                                                    <td className='tech_loop_td'>{techdataaa.TechPercentage}</td>
                                                </tr>
                                                <tr className='sub_tr2'>
                                                    <td colSpan='4'>  {techdataaa.Techfromwhere}</td>
                                                </tr>
                                        </tbody>
                                        )
                                    )
                                }
                            
                        </table>
                        <table className='DesThirdpassportdet'>
                            <caption className='desthirdpassportcaption'>Passport Details</caption>
                            
                            <tbody>
                                <tr>
                                    <td>Name</td>
                                    <td>{props.UsersPersonlD.Name}</td>
                                </tr>
                                <tr>
                                    <td>Passport Number</td>
                                    <td>{props.sendpassportdata.paassportnumber}</td>
                                </tr>
                                <tr>
                                    <td>Issuing Date</td>
                                    <td>{props.sendpassportdata.passportissuingdate}</td>
                                </tr>
                                <tr>
                                    <td>Expiry Date</td>
                                    <td>{props.sendpassportdata.passportexpirydate}</td>
                                </tr>
                                <tr>
                                    <td>District</td>
                                    <td>{props.sendpassportdata.passportdistrict}</td>
                                </tr>
                            </tbody>
                        </table>


                        <table className='DesThirdphysicaldet'>
                            <caption className='desthrdphysicalcaption'>Physical Details</caption>
                        
                            <tbody>
                                <tr>
                                    <td>Height</td>  
                                    <td>Weight</td>
                                    <td>Blood Group</td>
                                    <td>PwP Disability</td>
                                </tr>
                                <tr>
                                    <td>{props.sendphysicaldata.Height}</td>
                                    <td>{props.sendphysicaldata.weight}</td>
                                    <td>{props.sendphysicaldata.BloodGroup}</td>
                                    <td>{props.sendphysicaldata.Pwpdisability}</td>
                                </tr>
                            
                            
                            </tbody>
                        </table> 
                    <div className='working_exp_cont'>
                        <h3 className='working_exp_heading'>Working Experiance Bharat and Abroad</h3>
                        <ul>
                        {  
                            props.ExperienceData.map(
                                ExpdataToExpComp =>( 
                                    <li className='loop_li_of_exp'>
                                        <span>{ExpdataToExpComp.ExperianceYear} </span>
                                        {ExpdataToExpComp.Year} 
                                        <span> {ExpdataToExpComp.CompanyName} </span> 
                                        {ExpdataToExpComp.At} 
                                        <span> {ExpdataToExpComp.CompanyAddress} </span> 
                                        {ExpdataToExpComp.From} 
                                        <span> {ExpdataToExpComp.FromDateToDate } </span>
                                    </li>
                                )
                            )
                        }
                                    
                                    
                        </ul>
                    </div>
                </div>
            </div>
            
            

            <div className='printbtn' style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <button style={{padding: "10px 20px", backgroundColor: "lightblue", border: "none", color: "black", borderRadius: "5px",  fontSize: "22px"}} onClick={printfunction}>Print</button>
            </div>
        </div>
    );
}
export default DesignThird;